import Permission, { key } from '../../api/permission'
import { AppString } from '../../strings'
import { Pagination } from '../common.js'

const pagination  = new Pagination(Permission)

const state = {
    ...pagination.state,
}

const getters = {
    ...pagination.getters
}

const actions = {
    ...pagination.actions,

    update({ commit, dispatch }, payload) {
        return Permission.update(payload[key], payload.params).then(response => {
            if (response.status === 200) {
                commit('UPDATE_PERMISSION', {
                    [key]: payload[key],
                    permission: response.data
                })
                dispatch('notifications/addSuccessNotification', AppString.permissionUpdated, { root: true })
            }

            return response
        })
    },

    save({ commit, dispatch }, payload) {
        return Permission.create(payload).then(response => {
            
            if (response.status === 201) {
                commit('ADD_PERMISSION', response.data)
                dispatch('notifications/addSuccessNotification', AppString.permissionCreated, { root: true })
            }

            return response
        })
    },

    delete({ commit, dispatch }, permission) {
        return Permission.delete(permission[key]).then(response => {
            if (response.status === 204) {
                commit('DELETE_PERMISSION', permission)
                dispatch('notifications/addSuccessNotification', AppString.permissionDeleted, { root: true })
            }

            return response
        })
    },

    view(_, permission) {
        // REVIEW: should this have have a VIEW mutation?
        return Permission.view(permission[key]).then(response => {
            if (response.status === 200) {
                const data = response.data

                return {
                    name: data.name,
                    description: data.description
                }
            }
        })
    }
}

const mutations = {
    ...pagination.mutations,

    ADD_PERMISSION(state, permission) { 
        state.all.unshift(permission) 
        ++state.pagination.itemsLength
    },

    UPDATE_PERMISSION: (state, payload) => {
        const permission = state.all.find(permission => 
            permission[key].toLowerCase() === payload[key].toLowerCase())

        if (permission)
            Object.assign(permission, payload.permission)
    },

    DELETE_PERMISSION: (state, permission) => {
        const index = state.all.findIndex(item => item === permission)

        if (index >= 0)
            state.all.splice(index, 1)
    }

}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
